import { requestWithAbort, type RequestResponse } from '@atlassian/twg-common/request';

import type { AvailableProductsResponse } from '../types/site';

/**
 * Fetch the list of Atlassian sites/products available to the current
 * user from the App Switcher gateway endpoint.
 *
 * Used at the top of the LoggedIn flow (via `availableSitesAtom`) to
 * resolve which `cloudId` should be used for downstream data fetching,
 * and rendered by `SiteSwitcher` so the user can switch between
 * tenants.
 */
export const requestAvailableProducts = (): {
	controller: AbortController;
	execute: Promise<RequestResponse<AvailableProductsResponse>>;
} => {
	const { execute, controller } = requestWithAbort<AvailableProductsResponse>(
		'get',
		'/gateway/api/app-switcher/api/available-products?source=app-switcher-fe&product=twg-microsite-bifrost',
		null,
		{
			'Atl-App-Switcher-Private-API': 'true',
		},
	);
	return { controller, execute };
};
